/**
 * ADRESSEN TIL DØRA `/concerts/$kind/$id` (Del 1 B.1).
 *
 * Konsertsiden med egne faner er borte; døra åpner programposten. En gammel lenke med `?tab=` (Reise,
 * Overnatting …) lander på programpostens fane med samme navn. Bare fanene programposten har, slippes
 * gjennom; resten gir programpostens første fane, som `resolveTab` der avgjør.
 */
const PASSED_TABS = ['overview', 'people', 'tasks', 'travel', 'stay', 'advance', 'chat'] as const;
export type ConcertPageTab = (typeof PASSED_TABS)[number];

export interface ConcertPageSearch {
  tab?: ConcertPageTab;
}

export function validateConcertPageSearch(search: Record<string, unknown>): ConcertPageSearch {
  const tab = search['tab'];
  return typeof tab === 'string' && (PASSED_TABS as readonly string[]).includes(tab)
    ? { tab: tab as ConcertPageTab }
    : {};
}
